{
  "de": {
    "ai": {
      "activation": {
        "activate": "Aktivieren",
        "activated": "Der KI-Assistent ist für {client} aktiviert.",
        "agreement_required": "Setzen Sie zuerst das Häkchen zur Zustimmung.",
        "deactivated": "Der KI-Assistent ist für {client} ausgeschaltet.",
        "not_now": "Nicht jetzt",
        "prompt": {
          "agreement": "Im Namen von {client} stimme ich Google Cloud als Unterauftragsverarbeiter für diese Funktion zu.",
          "dpa_label": "Aktualisierter Auftragsverarbeitungsvertrag",
          "dpa_url": "https://ziggu.io/terms-and-conditions-13-10-2026",
          "intro": "Lassen Sie Konversationen zusammenfassen und Antworten vorschlagen. Bis zum 31. Dezember 2026 kostenlos testen.",
          "processing": "Für den Assistenten wird der Text von Konversationen über Google Cloud (Gemini) innerhalb der EU verarbeitet. Google verwendet diese Daten nicht zum Trainieren von Modellen.",
          "retention": "Konversationen mit dem Assistenten bewahren wir {count} Monat auf. | Konversationen mit dem Assistenten bewahren wir {count} Monate auf.",
          "settings": "Sie können den Assistenten jederzeit in den Einstellungen unter {features} > {conversations} ein- oder ausschalten.",
          "title": "Neu: KI-Assistent für Ihr Projektteam"
        },
        "settings": {
          "description": "Fasst Konversationen zusammen und schlägt Antworten vor. Zum Aktivieren stimmen Sie Google Cloud als Unterauftragsverarbeiter zu.",
          "impersonation": "Nur ein Inhaber des Kunden kann dies selbst ein- oder ausschalten, nicht in einer „Anmelden als“-Sitzung.",
          "owner_only": "Bitten Sie einen Inhaber, den KI-Assistenten zu aktivieren.",
          "owner_only_enabled": "Nur ein Inhaber kann den KI-Assistenten ausschalten.",
          "title": "KI-Assistent",
          "toggle": "KI-Assistent in Konversationen"
        },
        "snoozed": "Sie können den KI-Assistenten später in den Einstellungen unter {features} > {conversations} aktivieren."
      },
      "assistant": {
        "all_projects": "Alle Projekte",
        "cap": {
          "action": "Neue Konversation starten",
          "message": "Sie haben das Konversationslimit erreicht."
        },
        "empty_state": {
          "subtitle": "Fragen Sie mich alles über Ihre Kunden",
          "title": "Wie kann ich Ihnen helfen?"
        },
        "errors": {
          "budget_reached": "Das KI-Budget dieses Monats ist aufgebraucht. Wenden Sie sich an Ziggu, um es zu erhöhen.",
          "generic": "Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut."
        },
        "history": {
          "empty": "Noch keine früheren Konversationen",
          "title": "Frühere Konversationen"
        },
        "input": {
          "disclaimer": "Ergebnisse können ungenau sein. Überprüfen Sie wichtige Informationen immer.",
          "hint": "Enter zum Senden · Shift+Enter für neue Zeile",
          "placeholder": "Fragen Sie zu Ihren Kunden..."
        },
        "name": "Ziggy",
        "suggestions": {
          "help_notifications": "Wie richte ich Benachrichtigungen ein?",
          "help_project_settings": "Wo finde ich die Projekteinstellungen?",
          "open_decisions": "Welche Entscheidungen sind noch offen?",
          "unassigned_units": "Welche Einheiten haben noch keinen Kunden?"
        },
        "support_cta": {
          "action": "Support kontaktieren",
          "prompt": "Nicht die Antwort, die Sie gesucht haben?"
        }
      },
      "dashboard": {
        "agents": {
          "all": "Alle Module",
          "assistant": "Assistent",
          "conversation_agent": "Konversationsagent",
          "label": "Modul"
        },
        "allowance": {
          "edit": "Budget bearbeiten"
        },
        "allowance_boost": {
          "action": "Vorübergehend erhöhen",
          "action_short": "Erhöhen",
          "amount_label": "Zusätzlicher Betrag",
          "existing": "In dieser Periode läuft bereits eine Erhöhung von {amount}. Dieser Betrag kommt dazu.",
          "expires": "Kommt nur für diese Periode zum Budget hinzu und verfällt am {date}.",
          "expires_next_reset": "Kommt nur für diese Periode zum Budget hinzu und verfällt beim nächsten Zurücksetzen.",
          "save": "Erhöhung hinzufügen",
          "saved": "Erhöhung von {amount} hinzugefügt"
        },
        "allowance_history": {
          "empty": "Noch keine Änderungen",
          "empty_hint": "Dieser Kunde arbeitet noch mit dem ursprünglich vergebenen Budget.",
          "entry": "{field}: {before} → {after}",
          "package_amount": "Paketbetrag",
          "title": "Budgetverlauf",
          "unknown_author": "Unbekannt"
        },
        "chat_detail": {
          "employee": "Mitarbeiter",
          "empty": "Dieser Chat hat keine Nachrichten",
          "feedback": {
            "down": "Schlechte Antwort",
            "up": "Gute Antwort"
          },
          "text_hidden": "Vom Mitarbeiter nicht geteilt",
          "title": "Konversation"
        },
        "chats": {
          "columns": {
            "cost": "Kosten",
            "employee": "Mitarbeiter",
            "intent": "Absicht",
            "ticket": "Ticket",
            "turns": "Runden",
            "when": "Wann"
          },
          "empty": "Keine Chats in diesem Zeitraum",
          "feedback_label": "Bewertung",
          "feedbacks": {
            "all": "Jede Bewertung",
            "down": "Daumen runter",
            "up": "Daumen hoch"
          },
          "intent_label": "Absicht",
          "open": "Chat öffnen",
          "title": "Chats",
          "via": "über {name}"
        },
        "client": {
          "allowance_boost": "{amount} zusätzlich bis {date}",
          "allowance_boost_next_reset": "{amount} zusätzlich bis zum nächsten Zurücksetzen",
          "allowance_free": "{amount} kostenlos",
          "allowance_paid": "{amount} bezahlt",
          "employees_active": "{count} Mitarbeiter aktiv | {count} Mitarbeiter aktiv",
          "over_since": "Überschritten seit {date}",
          "title": "{name} · KI",
          "used": "{used} von {allowance} verbraucht"
        },
        "clients": {
          "allowance_split": "Kostenlos {free} · Bezahlt {paid}",
          "allowance_split_boost": "Kostenlos {free} · Bezahlt {paid} · Zusätzlich {boost}",
          "columns": {
            "actions": "Aktionen",
            "allowance": "Budget",
            "chats": "Chats im Zeitraum",
            "client": "Kunde",
            "spend": "Ausgaben im Zeitraum",
            "status": "Status",
            "used": "Diesen Monat verbraucht"
          },
          "empty": "Kein Kunde hat in diesem Zeitraum KI genutzt",
          "export": "Exportieren",
          "title": "Kunden"
        },
        "empty_hint": "Keine Treffer für dieses Modul und diesen Zeitraum.",
        "intent_mix": {
          "empty": "Keine Chats in diesem Zeitraum",
          "row": "{chats} Chat · {amount} | {chats} Chats · {amount}",
          "title": "Verteilung nach Absicht"
        },
        "intents": {
          "all": "Alle Absichten",
          "draft": "Antwort entwerfen",
          "none": "Ohne Absicht",
          "question": "Fragen",
          "summary": "Zusammenfassung"
        },
        "kpi": {
          "clients_active": "Aktive Kunden",
          "employees_active": "Aktive Mitarbeiter",
          "spend_month": "Ausgaben diesen Monat",
          "spend_month_detail": "Laufender Kalendermonat",
          "spend_range": "Ausgaben im Zeitraum",
          "spend_range_detail": "{count} Konversation in diesem Zeitraum | {count} Konversationen in diesem Zeitraum",
          "spend_today": "Ausgaben heute",
          "tickets_assisted": "Unterstützte Tickets"
        },
        "load_failed": {
          "description": "Laden Sie die Seite neu oder wählen Sie einen anderen Zeitraum.",
          "title": "KI-Nutzung konnte nicht geladen werden"
        },
        "range": {
          "label": "Zeitraum"
        },
        "spend": {
          "empty": "Keine Ausgaben in diesem Zeitraum",
          "monthly_empty": "Keine Ausgaben in den letzten {months} Monaten",
          "monthly_hint": "Letzte {months} Monate · unabhängig vom gewählten Zeitraum",
          "monthly_title": "Kosten pro Monat",
          "monthly_total": "{amount} in den letzten {months} Monaten · unabhängig vom gewählten Zeitraum",
          "title": "Ausgaben pro Tag",
          "total": "{amount} im Zeitraum",
          "view": {
            "label": "Ausgaben anzeigen",
            "per_day": "Pro Tag",
            "running_total": "Kumuliert"
          }
        },
        "status": {
          "over": "Budget überschritten",
          "over_days": "Überschritten · 1 Tag | Überschritten · {count} Tage"
        },
        "title": "KI-Nutzung"
      },
      "settings": {
        "budget": {
          "amount_error": "Betrag wie 2 oder 2.50 eingeben",
          "boost_label": "Vorübergehende Erhöhung",
          "boost_label_until": "Vorübergehende Erhöhung bis {date}",
          "description": "Monatliche Kostenobergrenze für die KI-Nutzung (Testphase). Wird basierend auf der Token-Nutzung in allen Konversationen dieses Monats neu berechnet.",
          "free_label": "Kostenloses Budget",
          "override_help": "Leer lassen, um den Paketbetrag zu verwenden ({amount}).",
          "override_label": "Individuelles kostenloses Budget",
          "paid_label": "Bezahltes Budget",
          "save": "Speichern",
          "title": "Monatliches Budget",
          "total_label": "Gesamtbudget",
          "usage_label": "Diesen Monat verbraucht",
          "usage_of": "Diesen Monat verbraucht, von {amount}",
          "use_package_amount": "Paketbetrag verwenden"
        },
        "description": "Konfiguration der KI-Funktionen in Ihrer Organisation.",
        "title": "KI-Einstellungen",
        "usage": {
          "description": "Wie viel des KI-Kontingents in diesem Monat verbraucht ist. Bei 100 % stoppen die KI-Funktionen, bis das Kontingent im nächsten Monat zurückgesetzt wird.",
          "title": "KI-Nutzung"
        }
      },
      "ticket_assistant": {
        "actions": {
          "adjust": "Anpassen",
          "ask": "Fragen",
          "draft": "Antwort entwerfen",
          "draft_empty": "Noch keine Nachrichten zum Beantworten",
          "follow_up": "Rückfrage",
          "follow_up_stop": "Rückfrage beenden",
          "new": "Neue Frage",
          "summary": "Konversation zusammenfassen",
          "summary_empty": "Noch keine Nachrichten zum Zusammenfassen",
          "use_as_reply": "Als Antwort verwenden"
        },
        "adjusting_draft": "Anpassung dieses Entwurfs",
        "beta": "Beta",
        "beta_tooltip": "Kostenlos bis Ende 2026. Danach wird die Nutzung begrenzt.",
        "budget": {
          "description": "Das KI-Budget dieses Monats ist aufgebraucht. Frühere Antworten bleiben verfügbar.",
          "request": "Wir haben das KI-Budget dieses Monats aufgebraucht und möchten es erhöhen.",
          "request_low": "Wir haben das KI-Budget dieses Monats fast aufgebraucht und möchten es erhöhen.",
          "title": "KI-Budget erreicht",
          "warn": "{percent} % des KI-Budgets dieses Monats verbraucht."
        },
        "cap": "Dieser Chat ist lang geworden. Stellen Sie besser eine neue Frage.",
        "collapse": "Assistent ausblenden",
        "conversation": "Konversation",
        "digest": {
          "decisions_open": "keine offenen Entscheidungen | 1 offene Entscheidung | {count} offene Entscheidungen",
          "installments_unpaid": "keine unbezahlten Raten | 1 unbezahlte Rate | {count} unbezahlte Raten",
          "issues_open": "keine offenen Nachbetreuungsmeldungen | 1 offene Nachbetreuungsmeldung | {count} offene Nachbetreuungsmeldungen",
          "nothing_open": "Nichts offen für diese Einheit",
          "overdue": "{count} überfällig",
          "title": "Auf einen Blick"
        },
        "earlier_answers": "Frühere Antworten",
        "empty": "Fragen Sie etwas zu dieser Konversation, oder beginnen Sie mit einer davon.",
        "expand": "Assistent einblenden",
        "feedback": {
          "bad": "Schlechte Antwort",
          "consent": "Ziggu sieht diese Unterhaltung. Sie kann Namen und Angaben von Kunden enthalten.",
          "consent_shared": "Diese Unterhaltung ist bereits mit Ziggu geteilt.",
          "good": "Gute Antwort",
          "note": "Was hätte es sagen sollen? (optional)",
          "send": "Senden",
          "share": "Mit Ziggu teilen",
          "stop_sharing": "Nicht mehr teilen",
          "thanks": "Danke für Ihr Feedback.",
          "thanks_shared": "Danke. Mit Ziggu geteilt.",
          "undo": "Rückgängig"
        },
        "following_up": "Rückfrage zu dieser Antwort",
        "footer": "Der Ziggu-Support liest dies nur, wenn Sie es teilen oder Ziggu Zugriff geben. Antworten werden von KI erstellt und können Fehler enthalten.",
        "footer_shared": "Sie haben diese Unterhaltung mit Ziggu geteilt. Antworten werden von KI erstellt und können Fehler enthalten.",
        "input": {
          "adjust_draft": "Entwurf anpassen, z. B. kürzer oder förmlicher",
          "follow_up": "Rückfrage stellen",
          "label": "Ihre Frage",
          "placeholder": "Fragen zu dieser Konversation"
        },
        "links": {
          "aftercare": "Nachbetreuung",
          "decisions": "Entscheidungen",
          "financials": "Finanzen"
        },
        "placeholders": {
          "confirm": {
            "accept": "Trotzdem senden",
            "header": "Mit Platzhaltern senden?",
            "message": "Der Assistent hat in dieser Antwort 1 Platzhalter hinterlassen, den Sie noch nicht ausgefüllt haben. | Der Assistent hat in dieser Antwort {count} Platzhalter hinterlassen, die Sie noch nicht ausgefüllt haben."
          },
          "remaining": "noch 1 Platzhalter ausfüllen | noch {count} Platzhalter ausfüllen"
        },
        "replace_reply": {
          "confirm": {
            "accept": "Ersetzen",
            "header": "Ihren Text ersetzen?",
            "message": "Der Entwurf ersetzt den Text im Antwortfeld."
          }
        },
        "resize": "Assistentenbreite anpassen",
        "suggestions": {
          "history": "Wie ist die Historie mit diesem Kunden?",
          "issues_open": "Wie viele Nachbetreuungspunkte sind noch offen?",
          "undecided": "Was hat dieser Kunde noch nicht entschieden?"
        },
        "thinking": "Der Assistent arbeitet...",
        "title": "Assistent"
      }
    }
  }
}
